const statusCodes = {
  2: {
    id: 2,
    label: 'Cancellation - Not Completed',
    className: 'status-error',
  },
  11: {
    id: 11,
    label: 'Not Completed',
    className: 'status-error',
  },
  17: {
    id: 17,
    label: 'Unknown Error',
    className: 'status-error',
  },
  22: {
    id: 22,
    label: 'Cancellation - Not Completed',
    className: 'status-error',
  },
  30: {
    id: 30,
    label: 'Reserved',
    className: 'status-reserved',
  },
  31: {
    id: 31,
    label: 'Cancelled',
    className: 'status-error',
  },
  32: {
    id: 32,
    label: 'Pending',
    className: 'status-pending',
  },
  46: {
    id: 46,
    label: 'Wait List',
    className: 'status-pending',
  },
  67: {
    id: 67,
    label: 'Cancellation - Not Completed',
    className: 'status-error',
  },
}

export const cancelledCodes = [2, 22, 31, 67]

export default statusCodes
